// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/relevance_map.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { SitePurpose } from "../../enum/v1/site_purpose_pb.js";
import { Relevance } from "./relevance_pb.js";

/**
 * @generated from message fingertip.common.type.v1.RelevanceMap
 */
export const RelevanceMap = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.RelevanceMap",
  () => [
    { no: 4, name: "created_at", kind: "message", T: Timestamp },
    { no: 5, name: "updated_at", kind: "message", T: Timestamp },
    { no: 53, name: "purpose", kind: "enum", T: proto3.getEnumType(SitePurpose) },
    { no: 54, name: "business_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 55, name: "relevance", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: Relevance} },
  ],
);

